export default "__VITE_ASSET__CEUmHwvs__"